<template>
    <div class="HouseingAssignmentsPane">
        <div class="container-fluid">
            <div class="row record-section-row">
                <div class="col">
                    <div v-if="IsPNWILS == false">
                        <HousingAssignments v-if="IsPNWILS == false" v-bind:child-record-data="ChildRecordData"
                                            Title="Housing Assignments"
                                            add-method="TAY/Clients/AssignResidenceToClientSubProgramMembership"
                                            options-method="TAY/Clients/GetResidencesForSubProgram"
                                            transfer-method="TAY/Clients/TransferResidenceToClientSubProgramMembership"
                                            delete-method="TAY/Clients/DeleteResidenceToClientSubProgramMembership"
                                            :field-data="ChildRecordData.ResidenceMemberships"
                                            :edit-mode="EditMode" />
                    </div>
                    <div v-if="IsPNWILS == true">
                        <h4>Living Situation:</h4>
                        <LivingSituationEditor :situation-data="ChildRecordData.LivingSituations"
                                               :chart-id="ChildRecordData.Id"
                                               :edit-mode="EditMode" 
                                               :is-ils="true"/>
                    </div>
                </div>
                
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import PersonEditor from '../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import HousingAssignments from "../../../Core/ItemEditors/HousingAssignments.vue";
    import LivingSituationEditor from './LivingSituationEditorTay.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            PersonEditor,
            EditMode,
            HousingAssignments,
            LivingSituationEditor
        },
        mounted() {

        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            IsPNWILS: function () {
                if (this.ChildRecordData.SubProgramID.toUpperCase() == "EBDA4D2B-FD9C-4135-804E-5132296063CA") {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
</style>